import blocklistApi from "@/api/blocklist";
import notify from "@/utils/notify";

const MAX_CACHE_DURATION_IN_MINUTES = 5;

const putBlocklistIntoLocalCache = (blocklist, isLoggedIn) => {
  const data = JSON.stringify({
    expiresAt: (new Date).getTime() + MAX_CACHE_DURATION_IN_MINUTES * 60000,
    isLoggedIn,
    blocklist
  });
  sessionStorage.setItem("content-blocklist", data);
};

const loadBlocklistFromLocalCache = (isLoggedIn) => {
  try {
    const data = JSON.parse(sessionStorage.getItem("content-blocklist"));
    if (data.expiresAt <= (new Date).getTime() || data.isLoggedIn !== isLoggedIn) {
      return null;
    } else {
      return data.blocklist;
    }
  } catch (_) {
    return null;
  }
};

export const getBlocklist = async ({ isLoggedIn }) => {
  let blocklist = loadBlocklistFromLocalCache(isLoggedIn);
  if (!blocklist) {
    try {
      blocklist = await blocklistApi.blockedItems();
      putBlocklistIntoLocalCache(blocklist, isLoggedIn);
    } catch (e) {
      notify(`Failed to fetch blocklist - using empty fallback! Error: ${e}`);
      blocklist = [];
    }
  }
  return blocklist;
};

export const isItemBlocked = (blocklist, itemType, itemId) => {
  return !!blocklist.find((item) => item.itemType === itemType && item.itemId === itemId);
};
